import React, { FC, ReactNode } from 'react';
import { ITrackShipment } from '../../interfaces/umbracoNodes/contentSlices';
import { ContentContainer } from '../base/contentContainer/contentContainer';
import GrayTextLink from '../grayTextLink';
import {
	ActionButtons,
	ColumnStyled,
	ColumnsStyled,
	IconButtonWithTextStyled,
	InputWrapper,
	RichTextTitleStyled,
	TrackContainer,
} from './trackShipment.styles';
import TrackShipmentInput from './trackShipmentInput';

interface Props {
	trackShipment: ITrackShipment;
	children?: ReactNode;
}

const TrackShipment: FC<Props> = ({ trackShipment, children }) => {
	return (
		<ContentContainer>
			<TrackContainer displayAsCard={trackShipment.Values.DisplayAsCard}>
				<RichTextTitleStyled
					content={trackShipment.Values.Title}
					type={trackShipment.Values.DisplayAsCard ? 'h3' : 'h1'}
				/>
				<InputWrapper>
					<TrackShipmentInput placeholder={trackShipment.Values.InputPlaceholder} />
				</InputWrapper>
				<GrayTextLink href={trackShipment.Values.GrayLink.Url} title={trackShipment.Values.GrayLink.Name} />
				{!children && trackShipment.Values.IconButtons && (
					<ActionButtons>
						<ColumnsStyled>
							{trackShipment.Values.IconButtons.map((item, index) => (
								<ColumnStyled key={index} mobile={1 / 4}>
									<IconButtonWithTextStyled
										iconUrl={item.Values.Icon.Src}
										title={item.Values.Button.Name}
										href={item.Values.Button.Url}
										taget={item.Values.Button.Target}
										shrinkForMobile
									/>
								</ColumnStyled>
							))}
						</ColumnsStyled>
					</ActionButtons>
				)}
				{children}
			</TrackContainer>
		</ContentContainer>
	);
};

export default TrackShipment;
